"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactGtmModule = _interopRequireDefault(require("react-gtm-module"));
var _reactHotjar = require("react-hotjar");
var _Environment = _interopRequireDefault(require("./Environment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Analytics = exports["default"] = /*#__PURE__*/function () {
  function Analytics() {
    _classCallCheck(this, Analytics);
  }
  return _createClass(Analytics, null, [{
    key: "initialize",
    value: function initialize() {
      console.log("Analytics: initialize");
      //if (Environment.isLocal) return Analytics.skipAnalytics();

      //GA
      /*ReactGA.initialize(Environment.isProduction ? this.GA_ID : this.GA_ID_TEST, {
              debug: Environment.isTest,
              titleCase: true
          });*/

      //Hot jar
      _reactHotjar.hotjar.initialize(_Environment["default"].isProduction ? this.HOTJAR_ID : this.HOTJAR_ID_TEST, this.HOTJAR_VERSION);
    }
  }, {
    key: "identify",
    value: function identify(user, organization) {
      console.log("Analytics: identify");
      //if (Environment.isLocal) return Analytics.skipAnalytics();

      //GA
      //ReactGA.set({ userId: user.employeeId });
      //ReactGA.set({ 'user_properties': this.getProperties(user, organization) });

      //GTM
      _reactGtmModule["default"].initialize({
        gtmId: this.GTM_ID,
        dataLayer: this.getProperties(user, organization),
        preview: _Environment["default"].isProduction ? undefined : "env-3"
      });

      //Hot jar
      _reactHotjar.hotjar.identify(user.employeeId, this.getProperties(user, organization));
    }
  }, {
    key: "getProperties",
    value: function getProperties(user, organization) {
      console.log("GTM Properties");
      var properties = {
        orgId: organization.organizationId,
        orgName: organization.name,
        orgTrial: organization.isTrial,
        orgStatus: organization.status.label,
        orgIsDemo: organization.isDemo,
        userId: user.loggedInUserEmployeeId,
        userFirstName: user.loggedInUserFirstName,
        userHasJob: user.loggedInUserHasJob,
        userJobTitle: user.loggedInUserJobTitle,
        userIsAdmin: user.loggedInUserIsOrganizationAdmin,
        userIsBillingAdmin: user.loggedInUserIsBillingUser,
        userIsManager: user.loggedInUserIsTeamLead
      };
      if (user.impersonating) properties = _objectSpread(_objectSpread({}, properties), {}, {
        /*impersonatedOrgId: organization.organizationId,
            impersonatedOrgName: organization.name,
            impersonatedOrgTrial: organization.isTrial,
            impersonatedOrgStatus: organization.status.label,
            impersonatedOrgIsDemo: organization.isDemo,*/
        impersonatedUserId: user.employeeId,
        impersonatedUserFirstName: user.firstName,
        impersonatedUserHasJob: user.hasJob,
        impersonatedUserJobTitle: user.jobTitle,
        impersonatedUserIsAdmin: user.isOrganizationAdmin,
        impersonatedUserIsBillingAdmin: user.isBillingUser,
        impersonatedUserIsManager: user.isTeamLead
      });
      console.log(properties);
      return properties;
    }
  }, {
    key: "event",
    value: function event(action, params) {
      console.log("Analytics: event " + action);
      //if (Environment.isLocal) return Analytics.skipAnalytics();

      //Hot jar
      _reactHotjar.hotjar.event(action);

      //GA
      //ReactGA.event({ category, action });

      //GTM
      _reactGtmModule["default"].initialize({
        gtmId: this.GTM_ID,
        events: _defineProperty({}, action, params)
      });
    }
  }, {
    key: "skipAnalytics",
    value: function skipAnalytics() {
      console.log("Skipping analytics for local environment");
    }
  }]);
}();
//Tracks prod and dev (test stream) only
_defineProperty(Analytics, "HOTJAR_ID", 2984320);
_defineProperty(Analytics, "HOTJAR_ID_TEST", 2984320);
_defineProperty(Analytics, "HOTJAR_VERSION", 6);
_defineProperty(Analytics, "GA_ID", "G-X4RZEX6QXR");
_defineProperty(Analytics, "GA_ID_TEST", "G-WDV68Y8EHD");
_defineProperty(Analytics, "GTM_ID", "GTM-PR3JZT3");